import WebGLView from './webgl/WebGLView';
import GUIView from './gui/GUIView';

import { QUESTIONS_COUNT, PARTICLES_CONFIG } from "../const";

export default class App {
	constructor({ texture }) {
    this.count = QUESTIONS_COUNT;
    this.texture = texture;

    this.resize = this.resize.bind(this);
    this.keyup = this.keyup.bind(this);
    this.handlerAnimate = this.animate.bind(this);
    this.click = this.click.bind(this);
  }

  setQuestions(questions) {
    this.questions = questions;

    const { uDepth, uRandom, uSize, uCurl } = PARTICLES_CONFIG;

    const calcRandomStep = ((uRandom.max - uRandom.min) / (this.count * 100)).toFixed(2);
    const calcDepthStep = ((uDepth.min - uDepth.max) / (this.count * 100)).toFixed(2);
    // const calcSizeStep = (uSize.max - uSize.min) / (this.count * 100);
    const calcCurlStep = ((uCurl.max - uCurl.min) / (this.count * 100)).toFixed(4);

    let currentSize = uSize.min;
    let currentDepth = uDepth.min;
    let currentRandom = uRandom.min;
    let currentCurl = uCurl.min;

    this.questions.onChange = (calculatedPercent, backward) => {
      if (calculatedPercent !== undefined) {
        const percent = 100 - calculatedPercent;

        // currentSize += backward ? percent * calcSizeStep * (-1) : percent * calcSizeStep;
        currentDepth -= backward ? percent * calcDepthStep * (-1) : percent * calcDepthStep;
        currentRandom += backward ? percent * calcRandomStep * (-1) : percent * calcRandomStep;
        currentCurl += backward ? percent * calcCurlStep * (-1) : percent * calcCurlStep;

        this.webgl.particles.updateValues(
          currentSize,
          currentDepth,
          currentRandom,
          currentCurl,
        );
      } else {
        currentSize = uSize.min;
        currentDepth = uDepth.min;
        currentRandom = uRandom.min;
        currentCurl = uCurl.min;

        this.webgl.particles.updateValues(uSize, uDepth, uRandom, uCurl);
      }
    }
  }

  destroy() {
    this.removeListeners();

    document.querySelector('#particles canvas').remove();
  }

	init(hideControls) {
    if (!hideControls) {
      this.initGUI();
    }

		this.initWebGL();
		this.addListeners();
		this.animate();
		this.resize();
	}

	initWebGL() {
		this.webgl = new WebGLView(this);
		document.querySelector('#particles').appendChild(this.webgl.renderer.domElement);
	}

	initGUI() {
		this.gui = new GUIView(this);
	}

  removeListeners() {
    window.removeEventListener('resize', this.resize);
		window.removeEventListener('keyup', this.keyup);

		const el = this.webgl.renderer.domElement;
		el.removeEventListener('click', this.click);
  }

	addListeners() {
		window.addEventListener('resize', this.resize);
		window.addEventListener('keyup', this.keyup);

		const el = this.webgl.renderer.domElement;
		el.addEventListener('click', this.click);
	}

	animate() {
		this.update();
		this.draw();
	}

	update() {
		if (this.gui && this.gui.stats) this.gui.stats.begin();
		if (this.webgl) this.webgl.update();
		if (this.gui && this.gui) this.gui.update();
	}

	draw() {
		if (this.webgl) this.webgl.draw();
		if (this.gui && this.gui.stats) this.gui.stats.end();
	}

	resize() {
		if (this.webgl) this.webgl.resize();
	}

	keyup(e) {
		if (e.keyCode == 71) { if (this.gui) this.gui.toggle(); }
	}

	click(e) {
		this.webgl.next();
	}
}
